/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCommentResponse
 */
export interface CreateCommentResponse {
    /**
     * The blockchain transaction hash
     * @type {string}
     * @memberof CreateCommentResponse
     */
    transactionHash?: string;
    /**
     * The blockchain block hash
     * @type {string}
     * @memberof CreateCommentResponse
     */
    blockHash?: string;
    /**
     * The blockchain block number/height
     * @type {number}
     * @memberof CreateCommentResponse
     */
    blockNumber?: number;
    /**
     * The ID of the created comment
     * @type {string}
     * @memberof CreateCommentResponse
     */
    commentId?: string;
}

/**
 * Check if a given object implements the CreateCommentResponse interface.
 */
export function instanceOfCreateCommentResponse(value: object): value is CreateCommentResponse {
    let isInstance = true;

    return isInstance;
}

export function CreateCommentResponseFromJSON(json: any): CreateCommentResponse {
    return CreateCommentResponseFromJSONTyped(json, false);
}

export function CreateCommentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCommentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionHash': !exists(json, 'transaction_hash') ? undefined : json['transaction_hash'],
        'blockHash': !exists(json, 'block_hash') ? undefined : json['block_hash'],
        'blockNumber': !exists(json, 'block_number') ? undefined : json['block_number'],
        'commentId': !exists(json, 'comment_id') ? undefined : json['comment_id'],
    };
}

export function CreateCommentResponseToJSON(value?: CreateCommentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction_hash': value.transactionHash,
        'block_hash': value.blockHash,
        'block_number': value.blockNumber,
        'comment_id': value.commentId,
    };
}

